import React, { useState, useEffect } from "react";
import { useViewportScroll, motion } from "framer-motion";

let myExperiences = [
  {
    id: 1,
    company: "SiteX DigiTech",
    role: "Flutter Developer",
    start: "Jul 2020",
    end: "Sep 2020",
    duration: "3",
  },
  {
    id: 2,
    company: "S. S. Foundation",
    role: "Graphic Designer",
    start: "Sep 2020",
    end: "Oct 2020",
    duration: "2",
  },
  {
    id: 3,
    company: "Investiture",
    role: "Flutter Developer",
    start: "Dec 2020",
    end: "May 2021",
    duration: "6",
  },
  {
    id: 4,
    company: "eduKshema",
    role: "Flutter Developer",
    start: "Dec 2020",
    end: "Aug 2021",
    duration: "9",
  },
  {
    id: 5,
    company: "GDSC JSSSTU",
    role: "Flutter Lead",
    start: "Sep 2020",
    end: "Jul 2022",
    isMoreThanYear: true,
    years: "1",
    duration: "11",
  },
  {
    id: 6,
    company: "Infoworks.io",
    role: "UI developer [React]",
    start: "Jan 2022",
    end: "Jul 2022",
    duration: "6",
  },
  {
    id: 7,
    company: "Juspay",
    role: "Software Developer",
    start: "Sep 2022",
    end: "Present",
    duration: "",
  },
];

const Experience = () => {
  const disableWidth = 880;
  const scrollFactor = 500;
  const { scrollYProgress } = useViewportScroll();
  const now = new Date();
  const past = new Date("2022-9-1");
  const [y, setY] = useState(0);

  let getDuration = () => {
    let years = now.getFullYear() - past.getFullYear() - 1;
    let month = now.getMonth() + years * 12 + (12 - past.getMonth() + 1);

    return {
      years: Math.floor(month / 12),
      month: month % 12,
    };
  };

  useEffect(() => {
    if (window.screen.width > disableWidth) {
      window.addEventListener("scroll", () => {
        setY(scrollYProgress.get() * scrollFactor);
      });
    }
  }, []);

  return (
    <div className="experience">
      <div className="container-fluid">
        <div className="wrapper center">
          <div className="experience-subtitle subtitle">EXPERIENCE</div>
          <motion.div
            style={window.screen.width < disableWidth ? {} : { y: -y + 100 }}
            className="experience-list"
          >
            <div className="dotted-line"></div>
            {myExperiences
              .map((experience, i) => (
                <div className="experience" key={experience.id}>
                  <div className="dot-left"></div>
                  <div className="dot-right"></div>
                  <div className="exp-title">
                    <div className="role">{experience.role}</div>
                    <span>@</span>
                    <div className="exp-company">{experience.company}</div>
                  </div>
                  <div className="exp-subtitle">
                    <div className="exp-start">{experience.start}</div>
                    <span>-</span>
                    <div className="exp-end">{experience.end}</div>
                    <span>//</span>
                    {i === myExperiences.length - 1 ? (
                      <div>
                        {getDuration().years > 0 && (
                          <>
                            <span className="exp-years">
                              {`${getDuration().years} yr`}&nbsp;
                            </span>
                            <span className="exp-months">{`${
                              getDuration().month + 1
                            } mos`}</span>
                          </>
                        )}
                        {!getDuration().years && (
                          <>
                            <div className="exp-months">{`${
                              getDuration().month + 1
                            } mos`}</div>
                          </>
                        )}
                      </div>
                    ) : (
                      <>
                        {experience.isMoreThanYear && (
                          <span className="exp-years">
                            {`${experience.years} yr`}&nbsp;
                          </span>
                        )}
                        <div className="exp-months">{`${experience.duration} mos`}</div>
                      </>
                    )}
                  </div>
                </div>
              ))
              .reverse()}
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Experience;
